import { useDocumentTitle } from "usehooks-ts";
import { DataTableContextProvider } from "../DataTable/DataTableContext";
import { DataTable } from "../DataTable/DataTable";
import Button from "../../../student/components/generic/button";
import { useState } from "react";
import { EditSchoolModal } from "./EditSchoolModal";
import { SnnSchool } from "./types";
import { useQueryClient } from "@tanstack/react-query";

const QUERY_KEY = "snnSchoolList";

export const SnnSchoolsPage: React.FC = () => {
  useDocumentTitle("SNN Schools");

  const queryClient = useQueryClient();
  const [activeSchool, setActiveSchool] = useState<SnnSchool | null>(null);

  return (
    <main className="flex flex-col gap-6 p-6">
      <h1 className="text-2xl font-bold">SNN Schools</h1>
      <DataTableContextProvider
        queryKey={QUERY_KEY}
        source="/manager_new/schools/snn/list"
        filterable={["schoolid", "schoolName", "state", "zip"]}
        defaults={{ sortBy: [{ id: "schoolid", desc: false }] }}
        globalFilter
        fetchOnLoad
        columnOverrides={{
          editSchool: ({ row }) => {
            const school = row.original as unknown as SnnSchool;
            return (
              <Button
                key={school.schoolid}
                type="link"
                onClick={() => setActiveSchool(school)}
              >
                Edit
              </Button>
            );
          },
        }}
      >
        <DataTable />
      </DataTableContextProvider>

      <EditSchoolModal
        school={activeSchool}
        onClose={() => setActiveSchool(null)}
        onSaved={() => {
          queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
          setActiveSchool(null);
        }}
      />
    </main>
  );
};
